import { render } from "./locale-changer.vue?vue&type=template&id=6c78cdfc"
import script from "./locale-changer.vue?vue&type=script&lang=js"
export * from "./locale-changer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__